import { inject, injectable } from "inversify";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { CPLMaintenanceDatesModel, ICPLAuthMaintenanceClient } from "./api/cplauthapi/CPLAuthAPI";
import { convertToDate, isDateInPast } from "cpl-react-common/Helpers/DateHelpers";

export interface IMaintenanceService {
  checkMaintenanceDates(): void;
  getMaintenanceDates(): Promise<CPLMaintenanceDatesModel>;
  convertMaintenanceDates(datesModel: CPLMaintenanceDatesModel): CPLMaintenanceDatesModel;
  checkIfDownForMaintenance(datesModel: CPLMaintenanceDatesModel): boolean;
}

@injectable()
export class MaintenanceService implements IMaintenanceService {
  @inject(SERVICE_TYPES.CPLAuthMaintenanceClient) cplAuthMaintenanceClient!: ICPLAuthMaintenanceClient;

  checkMaintenanceDates(): void {
    this.cplAuthMaintenanceClient.checkMaintenanceDates();
  }

  getMaintenanceDates(): Promise<CPLMaintenanceDatesModel> {
    return this.cplAuthMaintenanceClient.getMaintenanceDates();
  }

  checkIfDownForMaintenance(datesModel: CPLMaintenanceDatesModel): boolean {
    const { cplClientPortalMaintenanceDate } = datesModel;
    return isDateInPast(cplClientPortalMaintenanceDate);
  }

  convertMaintenanceDates(datesModel: CPLMaintenanceDatesModel): CPLMaintenanceDatesModel {
    const { cplClientPortalMaintenanceDate } = datesModel;

    return new CPLMaintenanceDatesModel({
      cplClientPortalMaintenanceDate: convertToDate(cplClientPortalMaintenanceDate) || undefined,
    });
  }
}
